import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import IncidentStatusEnum from 'redpoints-model-js/enumeration/IncidentStatusEnum';

import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';
import IncidentToReviewTaskController from 'redpoints-restapi-connector/controller/IncidentToReviewTaskController';
import LinkDataController from 'redpoints-restapi-connector/controller/LinkDataController';

import { Button, Loader, Notification } from 'redpoints-front-components/index';
import { withConfiguration } from 'redpoints-front-common/components';

import {
  reportedIncidentsClear,
  reportedIncidentsClearFilters,
  reportedIncidentsFetchDiscardReasons,
  reportedIncidentsSetDiscardReason,
  reportedIncidentsSetForm,
  reportedIncidentsSetOnReview,
} from '../../../actions/reportedIncidentsActions';
import {
  getReportedIncidents,
  getReportedIncidentsDiscardReasons,
  getReportedIncidentsSelectedDiscardReason,
} from '../../../reducers/tasks/reportedIncidents';
import {
  getReportedIncident,
  handleIncidentStatus,
  handleReportedIncidentsSubmit,
  mapReportedIncidentToParams,
  reportedIncidentIsEquals,
} from './ReportedIncidentsHelper';
import { translate } from '../../../helpers/languageHelper';
import ReportedIncidents from '../../../pages/Tasks/ReportedIncidents/ReportedIncidents';
import ReportedIncidentsDiscardReasonModal from '../../../pages/Tasks/ReportedIncidents/ReportedIncidentsDiscardReasonModal';
import ReportedIncidentsFilters from '../../../pages/Tasks/ReportedIncidents/ReportedIncidentsFilters';

import './reportedIncidents.less';

class ReportedIncidentsContainer extends Component {
  static getContextFromIncident(context, incident) {
    const customerId = incident?.customerId || null;
    const contractId = incident?.contractId || null;
    const newContext = cloneDeep(context);
    newContext.contractId = contractId;
    newContext.customerId = customerId;
    return newContext;
  }

  static isDisableButton(hasErrors, reportedIncidents, lock) {
    return (
      hasErrors ||
      lock ||
      reportedIncidentIsEquals(
        reportedIncidents.form,
        reportedIncidents.onReview
      )
    );
  }

  static footerReadOnly({ onDelay, readOnlyToggle, onDiscard, onAccept }) {
    return (
      <div className="reported-incidents-container__footer">
        <div className="reported-incidents-container__footer--align-start">
          <Button size="small" type="primary" onClick={readOnlyToggle}>
            {translate('incident_container.edit')}
          </Button>
          <Button size="small" type="warning" onClick={onDelay}>
            {translate('incident_container.delay')}
          </Button>
        </div>
        <div className="reported-incidents-container__footer--align-end">
          <Button size="small" type="secondary" onClick={onDiscard}>
            {translate('incident_container.discard')}
          </Button>
          <Button size="small" type="primary" onClick={onAccept}>
            {translate('incident_container.accept')}
          </Button>
        </div>
      </div>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      loadingData: null,
      readOnly: true,
      lockSaveButton: true,
      domainList: [],
      domainPlatformList: [],
      customerId: null,
      shouldRefreshFilters: false,
      filtersHaveBeenApplied: false,
      isDiscardReasonModalVisible: false,
    };
    this.getNextLink = this.getNextLink.bind(this);
    this.readOnlyToggle = this.readOnlyToggle.bind(this);
    this.onDelay = this.onDelay.bind(this);
    this.onDiscard = this.onDiscard.bind(this);
    this.onModalDiscardReasonCancel = this.onModalDiscardReasonCancel.bind(
      this
    );
    this.onModalDiscardReasonOk = this.onModalDiscardReasonOk.bind(this);
    this.onAccept = this.onAccept.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onFormChange = this.onFormChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onApplyFilters = this.onApplyFilters.bind(this);
    this.onClearFilters = this.onClearFilters.bind(this);
  }

  componentWillUnmount() {
    this.props.reportedIncidentsClear();
  }

  async onDelay() {
    const { getNextLink } = this;
    const { domainList, domainPlatformList, customerId } = this.state;
    const { context, reportedIncidents } = this.props;
    const newContext = ReportedIncidentsContainer.getContextFromIncident(
      context,
      reportedIncidents.onReview.incident
    );
    const response = await IncidentToReviewTaskController.delayNextToReview(
      newContext,
      reportedIncidents.onReview.incidentId
    );
    if (response && !response.error) {
      Notification.success({
        message: translate('tasks.reported_incidents.success.delayIncident'),
      });
      await getNextLink({ domainList, domainPlatformList, customerId });
    } else {
      Notification.error({
        message: translate('tasks.reported_incidents.error.delayIncident'),
      });
    }
  }

  async onModalDiscardReasonOk() {
    const { getNextLink } = this;
    const { context, reportedIncidents, selectedDiscardReason } = this.props;
    const { domainList, domainPlatformList, customerId } = this.state;
    const newContext = ReportedIncidentsContainer.getContextFromIncident(
      context,
      reportedIncidents.onReview.incident
    );
    const reportedIncidentsParams = mapReportedIncidentToParams(
      newContext,
      reportedIncidents.onReview
    );
    const response = await handleIncidentStatus({
      context,
      reportedIncidentsParams,
      status: IncidentStatusEnum.INCIDENT_DISCARDED,
      discardReason: selectedDiscardReason,
    });

    if (response.status !== HttpStatus.NO_CONTENT.value) {
      Notification.error({
        message: translate('tasks.reported_incidents.error.discardIncident'),
      });
    } else {
      Notification.success({
        message: translate('tasks.reported_incidents.success.discardIncident'),
      });
      this.setState({ isDiscardReasonModalVisible: false });
      await getNextLink({ domainList, domainPlatformList, customerId });
    }
  }

  onModalDiscardReasonCancel() {
    this.props.reportedIncidentsSetDiscardReason({
      discardReasonId: null,
    });
    this.setState({ isDiscardReasonModalVisible: false });
  }

  onDiscard() {
    if (this.props.discardReasons.length === 0) {
      this.props.reportedIncidentsFetchDiscardReasons();
    }
    this.setState({ isDiscardReasonModalVisible: true });
  }

  async onAccept() {
    const { getNextLink } = this;
    const { domainList, domainPlatformList, customerId } = this.state;
    const { context, reportedIncidents } = this.props;
    const newContext = ReportedIncidentsContainer.getContextFromIncident(
      context,
      reportedIncidents.onReview.incident
    );
    const reportedIncidentsParams = mapReportedIncidentToParams(
      newContext,
      reportedIncidents.onReview
    );
    const response = await handleIncidentStatus({
      context,
      reportedIncidentsParams,
    });
    if (response.status !== HttpStatus.NO_CONTENT.value) {
      Notification.error({
        message: translate('tasks.reported_incidents.error.confirmIncident'),
      });
    } else {
      Notification.success({
        message: translate('tasks.reported_incidents.success.confirmIncident'),
      });
      await getNextLink({ domainList, domainPlatformList, customerId });
    }
  }

  async onSubmit() {
    this.setState({
      lockSaveButton: true,
    });
    const { getNextLink } = this;
    const { customerId, domainList, domainPlatformList } = this.state;
    const { configuration, reportedIncidents, context } = this.props;
    const newState = { lockSaveButton: false };
    const newContext = ReportedIncidentsContainer.getContextFromIncident(
      context,
      reportedIncidents.onReview.incident
    );
    const { incidentDiscardedReasons } = configuration;

    const isSuccessful = await handleReportedIncidentsSubmit(
      newContext,
      reportedIncidents,
      incidentDiscardedReasons
    );
    if (isSuccessful) {
      Notification.success({
        message: translate('tasks.reported_incidents.success.processIncident'),
      });
      await getNextLink({ domainList, domainPlatformList, customerId });
      newState.readOnly = true;
    } else {
      Notification.error({
        message: translate('tasks.reported_incidents.error.processIncident'),
      });
    }
    this.setState(prevState => ({ ...prevState, ...newState }));
  }

  onCancel(formHandler) {
    const { readOnlyToggle } = this;
    const form = formHandler.getFieldsValue();
    formHandler.resetFields();
    this.props.reportedIncidentsSetForm({ form });
    readOnlyToggle();
  }

  onFormChange(form) {
    let reportIncidentsForm = form;

    if (typeof form.asset === 'number') {
      reportIncidentsForm = {
        ...reportIncidentsForm,
        asset: {
          assetId: form.asset,
        },
      };
    }

    if (typeof form.protectionType === 'string') {
      reportIncidentsForm = {
        ...reportIncidentsForm,
        protectionType: {
          protectionType: form.protectionType,
        },
      };
    }

    this.props.reportedIncidentsSetForm({
      form: reportIncidentsForm,
    });
    this.setState({ lockSaveButton: false });
  }

  async getNextLink({
    domainList = [],
    domainPlatformList = [],
    customerId = null,
  }) {
    this.setState({ loadingData: true });
    const { context } = this.props;
    const newState = {
      loadingData: false,
      shouldRefreshFilters: false,
    };

    const reportedIncident = await getReportedIncident({
      context,
      domainList,
      domainPlatformList,
      customerId,
    });

    const noMoreIncidents = isEmpty(reportedIncident);

    if (noMoreIncidents) {
      this.setState({
        shouldRefreshFilters: true,
        domainList: [],
        domainPlatformList: [],
      });
    } else {
      const newContext = ReportedIncidentsContainer.getContextFromIncident(
        context,
        reportedIncident.incident
      );
      const linkData = await LinkDataController.get(
        newContext,
        reportedIncident.incident.detectionLink.detectionLinkId
      );
      reportedIncident.title = linkData.response?.commonLinkData?.title;
      reportedIncident.images = (linkData.response?.linkImageList || []).map(
        ({ image }) => image.fullURL
      );
    }

    this.props.reportedIncidentsSetOnReview({
      onReview: reportedIncident,
    });
    this.setState(newState);
  }

  readOnlyToggle() {
    this.setState(prevState => ({
      readOnly: !prevState.readOnly,
      lockSaveButton: true,
    }));
  }

  async onApplyFilters({ domainList, domainPlatformList, customerId }) {
    this.setState({
      domainList,
      domainPlatformList,
      customerId,
      filtersHaveBeenApplied: true,
      readOnly: true,
    });
    await this.getNextLink({ domainList, domainPlatformList, customerId });
  }

  async onClearFilters() {
    const { reportedIncidentsClearFilters } = this.props;

    reportedIncidentsClearFilters();

    this.setState({
      domainList: [],
      domainPlatformList: [],
      filtersHaveBeenApplied: false,
    });
  }

  render() {
    const { onFormChange, onApplyFilters, onClearFilters } = this;
    const {
      loadingData,
      readOnly,
      lockSaveButton,
      shouldRefreshFilters,
      filtersHaveBeenApplied,
    } = this.state;
    const { reportedIncidents = {}, context } = this.props;

    const reportedIncidentsProps = {
      reportedIncidents: reportedIncidents.onReview,
      readOnly,
      onFormChange,
      filtersHaveBeenApplied,
      loadingData,
    };

    return (
      <>
        <ReportedIncidentsFilters
          shouldRefreshFilters={shouldRefreshFilters}
          context={context}
          onApplyFilters={onApplyFilters}
          onClearFilters={onClearFilters}
        />
        {loadingData ? (
          <Loader isLoading />
        ) : (
          <ReportedIncidents {...reportedIncidentsProps}>
            {(formHandler, hasErrors) => {
              const {
                onDelay,
                readOnlyToggle,
                onDiscard,
                onAccept,
                onSubmit,
                onCancel,
              } = this;
              let footerTpl = ReportedIncidentsContainer.footerReadOnly({
                onDelay,
                readOnlyToggle,
                onDiscard,
                onAccept,
              });
              if (!readOnly) {
                footerTpl = (
                  <div className="reported-incidents-container__footer">
                    <div className="reported-incidents-container__footer--align-start">
                      <Button
                        size="small"
                        type="secondary"
                        onClick={() => onCancel(formHandler)}
                      >
                        {translate('incident_container.cancel')}
                      </Button>
                      <Button
                        size="small"
                        type="primary"
                        onClick={onSubmit}
                        disabled={ReportedIncidentsContainer.isDisableButton(
                          hasErrors,
                          reportedIncidents,
                          lockSaveButton
                        )}
                      >
                        {translate('incident_container.save')}
                      </Button>
                    </div>
                  </div>
                );
              }
              return footerTpl;
            }}
          </ReportedIncidents>
        )}
        <ReportedIncidentsDiscardReasonModal
          isModalVisible={this.state.isDiscardReasonModalVisible}
          handleOnCancel={this.onModalDiscardReasonCancel}
          handleOnOk={this.onModalDiscardReasonOk}
        />
      </>
    );
  }
}

ReportedIncidentsContainer.propTypes = {
  reportedIncidentsSetOnReview: PropTypes.func,
  reportedIncidentsSetForm: PropTypes.func,
  reportedIncidentsFetchDiscardingReasons: PropTypes.func,
  reportedIncidents: PropTypes.shape(),
};

ReportedIncidentsContainer.defaultProps = {
  reportedIncidentsSetOnReview: () => null,
  reportedIncidentsSetForm: () => null,
  reportedIncidentsFetchDiscardingReasons: () => null,
  reportedIncidents: {},
};

const mapStateToProps = state => ({
  reportedIncidents: getReportedIncidents(state),
  discardReasons: getReportedIncidentsDiscardReasons(state),
  selectedDiscardReason: getReportedIncidentsSelectedDiscardReason(state),
});

export default compose(
  withRouter,
  withConfiguration,
  connect(mapStateToProps, {
    reportedIncidentsClear,
    reportedIncidentsClearFilters,
    reportedIncidentsFetchDiscardReasons,
    reportedIncidentsSetDiscardReason,
    reportedIncidentsSetForm,
    reportedIncidentsSetOnReview,
  })
)(ReportedIncidentsContainer);
